/* eslint-disable */
const $ = require('jquery')

// Push info of newsletter form to GTM
$('.newsletterSignup').submit(function (event) {
    dataLayer.push({
        event: 'newsletterSignup',
        email: $('#mce-EMAIL').val(),
    })
})

// Push office name of office listing enquiry form
$('.gtm-office-enquiry').submit(function (event) {
    dataLayer.push({
        event: 'officeEnquirySubmission',
        officeName: $(this).attr('id'),
    })
})

// Buyer enquiry form
$('.gtm-form-buyerEnquiry').submit(function (event) {
    dataLayer.push({
        event: 'buyerEnquirySubmission',
        investmentProperty: $(this).find('.fui-checkbox-input').is(':checked'),
    })
})

$('.gtm-form-contact').submit(function (event) {
    const $enquiryTypeField = $(this).find('name="fields[enquiryType]"')
    const selectedEnquiryType = $enquiryTypeField
        .find(`option[value=${$enquiryTypeField.val()}]`)
        .text()

    dataLayer.push({
        event: 'contactFormSubmission',
        enquiryType: selectedEnquiryType,
    })
})

$('.gtm-share-wishlist').submit(function (event) {
    dataLayer.push({
        event: 'submitModal',
        name: 'Share Wishlist',
    })
})

$('.gtm-btn-view-all').click((event) => {
    if ('agentViewAllContext' in event.target.dataset) {
        dataLayer.push({
            agentViewAllContext: event.target.dataset.agentViewAllContext,
        })
    }
})

$('.gtm-close-agent-card').click((event) => {
    const agentName = $('.js-agent-name').text()
    dataLayer.push({
        event: 'close-agent-card',
        agentName,
    })
})
